// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts-block {
  padding: 100px 80px 0 80px;
}
.contacts-block .contacts-top-wrapper {
  display: flex;
}
.contacts-block .contacts-top-wrapper .home-logo {
  margin-top: 40px;
  flex-grow: 1;
}
.contacts-block .contacts-top-wrapper .contacts-card {
  background-color: #f9fafb;
  border: 1px solid #eceef1;
  border-radius: 10px;
  padding: 26px 24px 34px 24px;
  text-align: center;
  width: 308px;
  height: 197px;
}
.contacts-block .contacts-top-wrapper .contacts-card .contacts-title {
  font-size: 22px;
  line-height: 150%;
  font-weight: 600;
  color: rgb(4, 14, 70);
}
.contacts-block .contacts-top-wrapper .contacts-card .contacts-card-divider {
  margin-top: 20px;
  margin-bottom: 20px;
  height: 1px;
  border-top: 1px solid #dee1e7;
}
.contacts-block .contacts-top-wrapper .contacts-card .contacts-card-phone {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  color: #3571d6;
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
  justify-content: center;
}
.contacts-block .contacts-top-wrapper .contacts-card .contacts-card-phone svg {
  margin-right: 8px;
}
.contacts-block .contacts-top-wrapper .contacts-card .contacts-card-phone a {
  color: #3571d6 !important;
}
.contacts-block .contacts-top-wrapper .contacts-card .contacts-card-email {
  margin-top: 10px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  color: #3571d6;
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
  justify-content: center;
}
.contacts-block .contacts-top-wrapper .contacts-card .contacts-card-email svg {
  margin-right: 8px;
}
.contacts-block .contacts-top-wrapper .contacts-card .contacts-card-email a {
  color: #3571d6 !important;
}
.contacts-block .contacts-divider {
  height: 1px;
  border-top: 1px solid #dee1e7;
  width: 100%;
  margin-top: 40px;
}
.contacts-block .contacts-footer {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 150%;
  margin-top: 24px;
  margin-bottom: 80px;
}
.contacts-block .contacts-footer .footer-links {
  display: flex;
  gap: 24px;
}
.contacts-block .contacts-footer .footer-links .cookies-settings-link {
  -webkit-text-decoration: underline solid rgb(68, 81, 105);
          text-decoration: underline solid rgb(68, 81, 105);
}

.contacts-block.isMobile {
  padding: 60px 20px 0 20px;
}
.contacts-block.isMobile .contacts-top-wrapper {
  flex-wrap: wrap;
  gap: 32px;
}
.contacts-block.isMobile .contacts-top-wrapper .home-logo {
  text-align: center;
  margin-top: 0;
}
.contacts-block.isMobile .contacts-top-wrapper .contacts-card {
  padding: 20px 24px 34px 24px;
  width: 100%;
  height: auto;
}
.contacts-block.isMobile .contacts-footer {
  flex-wrap: wrap;
  gap: 14px;
}
.contacts-block.isMobile .contacts-footer .rights-reserved {
  text-align: center;
  width: 100%;
}
.contacts-block.isMobile .contacts-footer .footer-links {
  width: 100%;
  gap: 14px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/Footer/styles.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;AACE;EACE,aAAA;AACJ;AACI;EACE,gBAAA;EACA,YAAA;AACN;AAEI;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAAN;AAEM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAAR;AAGM;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;AADR;AAIM;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAFR;AAIQ;EACE,iBAAA;AAFV;AAKQ;EACE,yBAAA;AAHV;AAOM;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AALR;AAOQ;EACE,iBAAA;AALV;AAQQ;EACE,yBAAA;AANV;AAYE;EACE,WAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAXJ;AAaI;EACE,aAAA;EACA,SAAA;AAXN;AAaM;EACE,yDAAA;UAAA,iDAAA;AAXR;;AAiBA;EACE,yBAAA;AAdF;AAgBE;EACE,eAAA;EACA,SAAA;AAdJ;AAgBI;EACE,kBAAA;EACA,aAAA;AAdN;AAiBI;EACE,4BAAA;EACA,WAAA;EACA,YAAA;AAfN;AAmBE;EACE,eAAA;EACA,SAAA;AAjBJ;AAmBI;EACE,kBAAA;EACA,WAAA;AAjBN;AAoBI;EACE,WAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAlBN","sourcesContent":[".contacts-block {\n  padding: 100px 80px 0 80px;\n\n  .contacts-top-wrapper {\n    display: flex;\n\n    .home-logo {\n      margin-top: 40px;\n      flex-grow: 1;\n    }\n\n    .contacts-card {\n      background-color: #f9fafb;\n      border: 1px solid #eceef1;\n      border-radius: 10px;\n      padding: 26px 24px 34px 24px;\n      text-align: center;\n      width: 308px;\n      height: 197px;\n\n      .contacts-title {\n        font-size: 22px;\n        line-height: 150%;\n        font-weight: 600;\n        color: rgba(4, 14, 70, 1);\n      }\n\n      .contacts-card-divider {\n        margin-top: 20px;\n        margin-bottom: 20px;\n        height: 1px;\n        border-top: 1px solid #dee1e7;\n      }\n\n      .contacts-card-phone {\n        display: flex;\n        margin-left: auto;\n        margin-right: auto;\n        align-items: center;\n        color: #3571d6;\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 150%;\n        justify-content: center;\n\n        svg {\n          margin-right: 8px;\n        }\n\n        a {\n          color: #3571d6 !important;\n        }\n      }\n\n      .contacts-card-email {\n        margin-top: 10px;\n        display: flex;\n        margin-left: auto;\n        margin-right: auto;\n        align-items: center;\n        color: #3571d6;\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 150%;\n        justify-content: center;\n\n        svg {\n          margin-right: 8px;\n        }\n\n        a {\n          color: #3571d6 !important;\n        }\n      }\n    }\n  }\n\n  .contacts-divider {\n    height: 1px;\n    border-top: 1px solid #dee1e7;\n    width: 100%;\n    margin-top: 40px;\n  }\n\n  .contacts-footer {\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    line-height: 150%;\n    margin-top: 24px;\n    margin-bottom: 80px;\n\n    .footer-links {\n      display: flex;\n      gap: 24px;\n\n      .cookies-settings-link {\n        text-decoration: underline solid rgba(68, 81, 105, 1);\n      }\n    }\n  }\n}\n\n.contacts-block.isMobile {\n  padding: 60px 20px 0 20px;\n\n  .contacts-top-wrapper {\n    flex-wrap: wrap;\n    gap: 32px;\n\n    .home-logo {\n      text-align: center;\n      margin-top: 0;\n    }\n\n    .contacts-card {\n      padding: 20px 24px 34px 24px;\n      width: 100%;\n      height: auto;\n    }\n  }\n\n  .contacts-footer {\n    flex-wrap: wrap;\n    gap: 14px;\n\n    .rights-reserved {\n      text-align: center;\n      width: 100%;\n    }\n\n    .footer-links {\n      width: 100%;\n      gap: 14px;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
